import VehiclesContainer from 'containers/VehiclesTabel/index'
import React from 'react'

const vehiclespage = () => {
  return (
   <>
   <VehiclesContainer/>
   </>
  )
}

export default vehiclespage